// extracted by mini-css-extract-plugin
export var container = "_mr-0";
export var dotAnimation = "_mr-2";
export var dotsLoading = "_mr-1";